import axios from 'axios';

const apiNotificacao = axios.create({
  baseURL: "https://maisescola-notificacoes.herokuapp.com/",  
});

export default apiNotificacao;
